import { Clock } from "lucide-react";
import {
  DEFAULT_MAINTENANCE_TITLE,
  DEFAULT_PROJECT_MAINTENANCE_MESSAGE,
  type MaintenanceSettings,
} from "@shared/maintenance";

/**
 * „Hamarosan" panel EGY projekt tartalma helyett (a projekt oldalán).
 *
 * Az oldal-szintű móddal ellentétben itt a projekt neve és borítója
 * megmarad — csak a javítás alatt álló tartalom (leírás, galéria, lakások,
 * árak, műszaki adatok) nem jelenik meg, és az URL sem törik el.
 */
export function ComingSoonPanel({
  maintenance,
}: {
  maintenance: MaintenanceSettings | null | undefined;
}) {
  const title = (maintenance?.title || "").trim() || DEFAULT_MAINTENANCE_TITLE;
  const message =
    (maintenance?.message || "").trim() || DEFAULT_PROJECT_MAINTENANCE_MESSAGE;
  return (
    <div className="border border-brand-200 bg-brand-50/60 px-6 py-14 text-center">
      <div className="w-12 h-12 mx-auto grid place-items-center bg-accent text-white">
        <Clock size={22} />
      </div>
      <h2 className="mt-6 font-heading uppercase tracking-ultrawide text-brand-700 text-2xl sm:text-3xl">
        {title}
      </h2>
      <p className="mt-4 mx-auto max-w-xl text-brand-600 leading-relaxed whitespace-pre-line">
        {message}
      </p>
    </div>
  );
}

/** Kis „Hamarosan" címke a projekt-kártyákra. */
export function ComingSoonBadge({ className = "" }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-1 bg-accent text-white px-2 py-1 text-[10px] uppercase tracking-widish font-semibold ${className}`}
    >
      <Clock size={11} />
      Hamarosan
    </span>
  );
}
